import Vec2D from './Vec2d';
import { Vector2, Vector3 } from 'three';
import * as THREE from 'three';

export class Bullet {
	constructor(model) {
		this.pos = new Vector3(0, 0, 0);
		this.vel = new Vector3(0, 0, 0);
		this.blacklisted = false;

		//const geometry = new THREE.BoxGeometry(1, 1, 1);
		//const material = new THREE.MeshLambertMaterial({ color: 0xff0000 });

		//this.mesh = new THREE.Mesh(geometry, material);

		let mesh = model.scene.children[0].clone();
		let mat = mesh.material.clone();
		mesh.material = mat;

		this.mesh = mesh;

		this.astBox = new THREE.Box3().setFromObject(this.mesh);
		//this.mesh.scale.set(0.3, 0.3, 0.3);

		return this;
	}

	update(type, size) {
		this.pos.add(this.vel);
		this.mesh.position.copy(this.pos);
		//this.mesh.rotation.z += 0.1;
	}

	reset() {
		this.blacklisted = false;
	}
}
